import { gql } from '@apollo/client/core';

export const getStates = gql`
  query getStates {
    getStates
  }
`;
